<template>

</template>
<script>
    import NoticeInnerLink from "components/homepage/NoticeInnerLink";
    import Vue from "vue";
    import { getNoticeDetailUrl } from "utils/notices";
    Vue.component("NoticeInnerLink", NoticeInnerLink);
    const cornerKey = "CORNER_STORAGE_KEY";
    const namePrefix = "topNotice";
    export default {
        props: {
            notices: {
                type: Array,
                required: true
            }
        },
        data: function() {
            return {
                topNotices: []
            };
        },
        created() {
            this.noticesHasRead = [];
            this.noticesShowing = [];
            if (window.localStorage) {
                try {
                    let noticesHasReadStr = window.localStorage.getItem(cornerKey);
                    if (noticesHasReadStr) {
                        this.noticesHasRead = JSON.parse(noticesHasReadStr);
                    }
                } catch (ex) {
                    console.error(err);
                }
            }
            if (this.notices && this.notices.length) {
                let noticeUnread = this.notices.find(noticeItem => {
                    return !this.noticesHasRead.includes(noticeItem.id);
                });
                if (noticeUnread) {
                    this.showTopNotice(noticeUnread);
                }
            }
        },
        destroyed() {
            this.noticesShowing.forEach(notice => {
                this.$Notice.close(namePrefix + notice);
            });
        },
        methods: {
            markAsRead(id) {
                window.open(getNoticeDetailUrl(id), "_blank");
                this.$Notice.close(namePrefix + id);
                if (!this.noticesHasRead.includes(id)) {
                    this.noticesHasRead.push(id);
                    if (window.localStorage) {
                        try {
                            window.localStorage.setItem(
                                cornerKey,
                                JSON.stringify(this.noticesHasRead)
                            );
                        } catch (err) {
                            console.error(err);
                        }
                    }
                }
            },
            showTopNotice(item) {
                if (this.noticesShowing.indexOf(item.id) !== -1) {
                    return;
                }
                this.noticesShowing.push(item.id);
                this.$Notice.info({
                    title: item.title,
                    desc: item.title,
                    duration: 0,
                    name: namePrefix + item.id,
                    onClose: () => {
                        this.noticesShowing.splice(this.noticesShowing.indexOf(item.id), 1);
                    },
                    render: h => {
                        return h("NoticeInnerLink", {
                            props: {
                                item: item
                            },
                            on: {
                                toDetail: id => {
                                    this.markAsRead(id);
                                }
                            }
                        });
                    }
                });
            }
        }
    };
</script>
<style lang="postcss">

</style>



// WEBPACK FOOTER //
// TopNotice.vue?e457326e